/** @jsxImportSource @emotion/react */
import React, { useMemo } from 'react';
import { locationStyles } from './location.styles';
import { SetUp } from '../../app/set-up/set-up.view';
import { LocationHeader } from '../../app/layouts/location/components/header/location-header.component';
import { useMediaQuery } from 'usehooks-ts';
import { useParams } from 'react-router-dom';
import { useLocationSocket } from '../../hooks/useLocationSocket';
import { useRedirectHomeOnNotFound } from '../../hooks/useRedirectHomeOnNotFound';
import { LocationImagesCarousel } from '../location-images-carousel/location-images-carousel.component';
import { LocationWorkingHours } from '../location-working-hours/location-working-hours.component';
import { LocationFooter } from '../../app/layouts/location/components/footer/location-footer.component';
import SwipeableEdgeDrawer from '../swipable-edge-drawer/swipable-edge-drawer.component';

const Location = () => {
    const isDesktop = useMediaQuery('(min-width:600px)');
    const { locationId } = useParams();
    const { location, locationLoading, locationError } = useLocationSocket(locationId);

    useRedirectHomeOnNotFound(locationError, locationLoading);

    const content = useMemo(() => {
        return (
            <div css={locationStyles.contentBox}>
                <LocationHeader />
                <LocationImagesCarousel images={location?.data?.images} />
                <SetUp location={location} locationLoading={locationLoading} />
                <LocationWorkingHours workingHours={location?.data?.workingHours} />
                <LocationFooter shouldShowAboutTitle={false} />
            </div>
        );
    }, [locationLoading, location]);

    if (isDesktop) {
        return <div css={locationStyles.desktopWrapper}>{content}</div>;
    }

    return <SwipeableEdgeDrawer>{content}</SwipeableEdgeDrawer>;
};

export default Location;
